import React, { useEffect, useState, useRef } from "react";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { MdOutlinePlace } from "react-icons/md";
import { Container } from "react-bootstrap";
import HTMLRenderer from "./htmlrender";

import { getHotelDetails } from "../store/slices/hotel";

export default function Hoteldetails() {
  const { id } = useParams();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const params = useParams();

  const placeIdParam = params.placeId;
  const placeNameParam = params.placeName;
  const checkInParam = params.checkIn;
  const checkOutParam = params.checkOut;
  const roomsParam = Number(params.rooms) || 1;
  const guestsParam = Number(params.guests) || 1;

  const [dateError, setDateError] = useState("");
  const [isloading, setisLoading] = useState(false);
  const [isRoomGuestOpen, setIsRoomGuestOpen] = useState(false);
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const dropdownRef = useRef(null);
  const firstRun = useRef(true);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [name, setName] = useState("");
  const [standardPrice, setstandardPrice] = useState("");
  const [availableRooms, setavailableRooms] = useState("");
  const [checkinTime, setcheckinTime] = useState("");
  const [checkoutTime, setcheckoutTime] = useState("");
  const [images, setImages] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [address, setAddress] = useState("");
  const [propertyType, setpropertyType] = useState("");
  const [starRating, setstarRating] = useState("");
  const [bookingPolicy, setbookingPolicy] = useState("");
  const [contact, setContact] = useState();

  const [description, setDescription] = useState();
  const [locality, setLocality] = useState();
  const [nearbyPlaces, setnearbyPlaces] = useState([]);
  const [roomtypes, setRoomtypes] = useState([]);

  const [city, setCity] = useState("");
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");

  const [rooms, setRooms] = useState([{ adults: 2, children: 0 }]);

  const [selectedOption, setSelectedOption] = useState(
    placeIdParam ? { _id: placeIdParam, name: placeNameParam || "" } : null
  );
  const effectivePlaceId = selectedOption?._id || placeIdParam;
  const [places, setPlaces] = useState([]);

  const [error, setError] = useState("");
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setCity(option.name);
    setIsEditing(false);
    setDropdownVisible(false);
    setError("");
  };

  const filteredOptions = places.filter((place) =>
    place.name.toLowerCase().includes(city.toLowerCase())
  );

  const toggleRoomDropdown = () => {
    setIsRoomGuestOpen(!isRoomGuestOpen);
  };
  useEffect(() => {
    const fetchHotelDetails = async () => {
      try {
        let item = { id };
        const data = await dispatch(getHotelDetails(item)).unwrap();

        const hotelDatas =
          data?.hotelData ||
          data?.hotelDetails?.hotelData ||
          data?.hotel?.hotelData;
        if (!hotelDatas) {
          return;
        }

        setAddress(hotelDatas.address || "");
        setName(hotelDatas.name || "");
        setpropertyType(hotelDatas.propertyType?._id || "");
        setcheckinTime(hotelDatas.checkinTime || "");
        setcheckoutTime(hotelDatas.checkoutTime || "");
        setavailableRooms(hotelDatas.availableRooms || "");
        setstandardPrice(hotelDatas.standardPrice || "");
        setstarRating(hotelDatas.starRating || "");
        setbookingPolicy(hotelDatas.bookingPolicy || "");
        setDescription(hotelDatas.description || "");
        setImages(hotelDatas.images || []);

        setLocality(hotelDatas.locality?.name || "");
        setContact(hotelDatas.contact || {});
        setAmenities(hotelDatas?.amenities || []);
        setRoomtypes(hotelDatas?.rooms || []);
        setnearbyPlaces(hotelDatas.nearbyPlaces || []);

        const navState = location?.state;
        if (navState) {
          if (navState.checkin) setCheckInDate(navState.checkin);
          if (navState.checkout) setCheckOutDate(navState.checkout);

          if (navState.place) {
            const placeName =
              hotelDatas.locality?.name || navState.placeName || "";
            setCity(placeName);
          }

          const roomCountVal = navState.roomCount
            ? parseInt(navState.roomCount, 10)
            : null;
          const paxVal = navState.pax ? parseInt(navState.pax, 10) : null;

          if (!isNaN(roomCountVal) && roomCountVal > 0) {
            setRooms(
              Array.from({ length: roomCountVal }, () => ({
                adults: 2,
                children: 0,
              }))
            );
          } else if (!isNaN(paxVal) && paxVal > 0) {
            setRooms([{ adults: paxVal, children: 0 }]);
          }
        }
      } catch (error) {
      } finally {
        setisLoading(false);
      }
    };
    fetchHotelDetails();
  }, [dispatch, id, location?.state]);

  const slides = images.map((img) => ({
    src: img.mediaLink,
    alt: img.name || "Hotel Image",
  }));

  const n = (v) => Number(v ?? 0);
  const getRoomTotalPrice = (room) => {
    const base = n(room.pricePerRoom);
    const addBreakfast = room.breakfast ? n(room.pricewithBreakfast) : 0;
    const addDinner = room.lunchOrdinner ? n(room.pricewithDinner) : 0;
    return base + addBreakfast + addDinner;
  };
  const updateRoomCount = (index, type, action) => {
    const updated = rooms.map((room, i) => {
      if (i === index) {
        return {
          ...room,
          [type]:
            action === "inc" ? room[type] + 1 : Math.max(0, room[type] - 1),
        };
      }
      return room;
    });
    setRooms(updated);
  };

  // add room
  const addRoom = () => {
    setRooms([...rooms, { adults: 2, children: 0 }]);
  };

  // remove room
  const removeRoom = (index) => {
    const updated = rooms.filter((_, i) => i !== index);
    setRooms(updated);
  };

  const totalGuests = rooms.reduce((sum, r) => sum + r.adults + r.children, 0);

  return (
    <>
      <Navbarsticky />

      <div className="hoteldetails-container"></div>

      <Container>
        <div className="hotellist-input d-flex justify-content-center">
          {/* <div className="hotellist-form filter-box p-4 flex-wrap shadow-sm">
            <Form.Group className="mb-3 mx-1" ref={dropdownRef}>
              <Form.Label className="filter-label">Destination</Form.Label>

              <div className="input-with-icon">
                <input
                  type="text"
                  className="filter-input"
                  value={city}
                  placeholder="Location or Hotel"
                  onChange={(e) => {
                    setCity(e.target.value);
                    setIsEditing(true);
                    setDropdownVisible(true);
                    setError("");
                  }}
                  onClick={() => {
                    setIsEditing(true);
                    setDropdownVisible(true);
                  }}
                />

                <i className="bi bi-geo-alt" />
              </div>

              {dropdownVisible && (
                <ul
                  style={{
                    listStyleType: "none",
                    padding: 0,
                    margin: "5px 0",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    maxHeight: "200px",
                    overflowY: "auto",
                    position: "absolute",
                    width: "260px",
                    backgroundColor: "#fff",
                    zIndex: 1000,
                  }}
                >
                  {selectedOption && (
                    <>
                      <li
                        style={{
                          padding: "5px",
                          fontWeight: "bold",
                          backgroundColor: "#f0f0f0",
                          borderBottom: "1px solid #ccc",
                        }}
                      >
                        Recently Selected
                      </li>
                      <li
                        onClick={() => handleOptionClick(selectedOption)}
                        style={{ padding: "5px", cursor: "pointer" }}
                      >
                        {selectedOption.name}
                      </li>
                    </>
                  )}

                  {filteredOptions.map((option) => (
                    <li
                      key={option._id}
                      onClick={() => handleOptionClick(option)}
                      style={{ padding: "5px", cursor: "pointer" }}
                    >
                      {option.name}
                    </li>
                  ))}
                </ul>
              )}

              {error && (
                <p style={{ color: "red", marginTop: "5px", fontSize: "12px" }}>
                  {error}
                </p>
              )}
            </Form.Group>

            <Form.Group className="mb-3 mx-1">
              <Form.Label className="filter-label">Check In</Form.Label>
              <div className="input-with-icon">
                <input
                  type="date"
                  className="filter-input"
                  value={checkInDate}
                  onChange={(e) => setCheckInDate(e.target.value)}
                />
                <i className="bi bi-calendar-date" />
              </div>
            </Form.Group>

            <Form.Group className="mb-3 mx-1">
              <Form.Label className="filter-label">Check Out</Form.Label>
              <div className="input-with-icon">
                <input
                  type="date"
                  className="filter-input"
                  value={checkOutDate}
                  onChange={(e) => setCheckOutDate(e.target.value)}
                />
                <i className="bi bi-calendar-date" />
              </div>
              {dateError && (
                <p style={{ color: "red", marginTop: "5px", fontSize: "12px" }}>
                  {dateError}
                </p>
              )}
            </Form.Group>

            <Form.Group className="mb-3 mx-1 roomguest-wrapper">
              <Form.Label className="filter-label">Room / Guest</Form.Label>

              <div className="roomguest-input" onClick={toggleRoomDropdown}>
                <input
                  readOnly
                  className="filter-input"
                  value={`${rooms.length} Room${
                    rooms.length > 1 ? "s" : ""
                  }, ${totalGuests} Guest${totalGuests > 1 ? "s" : ""}`}
                />
                <i className="bi bi-people roomguest-icon"></i>
              </div>

              {isRoomGuestOpen && (
                <div className="roomguest-dropdown">
                  {rooms.map((room, index) => (
                    <div className="roomguest-box" key={index}>
                      <h6 className="roomguest-title">Room {index + 1}</h6>

                      <div className="roomguest-row">
                        <span>Adult (Above 12yrs)</span>
                        <div className="roomguest-counter">
                          <button
                            onClick={() =>
                              updateRoomCount(index, "adults", "dec")
                            }
                          >
                            -
                          </button>
                          <span>{room.adults}</span>
                          <button
                            onClick={() =>
                              updateRoomCount(index, "adults", "inc")
                            }
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <div className="roomguest-row">
                        <span>Child (Below 12yrs)</span>
                        <div className="roomguest-counter">
                          <button
                            onClick={() =>
                              updateRoomCount(index, "children", "dec")
                            }
                          >
                            -
                          </button>
                          <span>{room.children}</span>
                          <button
                            onClick={() =>
                              updateRoomCount(index, "children", "inc")
                            }
                          >
                            +
                          </button>
                        </div>
                      </div>

                      {rooms.length > 1 && (
                        <button
                          className="roomguest-remove"
                          onClick={() => removeRoom(index)}
                        >
                          Remove Room
                        </button>
                      )}
                    </div>
                  ))}

                  <div className="roomguest-footer">
                    <button className="roomguest-add" onClick={addRoom}>
                      + Add Room
                    </button>
                    <button
                      className="roomguest-done"
                      onClick={toggleRoomDropdown}
                    >
                      Done
                    </button>
                  </div>
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-3 mx-2 mt-2">
              <Form.Label className="filter-label">&nbsp;</Form.Label>

              <button
                type="submit"
                className="take-tour-btn mt-4"
                //  onClick={hotelSearch}
              >
                Search <i className="bi bi-arrow-right ms-2" />
              </button>
            </Form.Group>
          </div> */}
        </div>
        <div className="container mt-3">
          <div className="tgs-hero-card">
            <div className="tgs-gallery">
              <div
                className="tgs-gallery-left"
                onClick={() => {
                  setIsOpen(true);
                  setPhotoIndex(0);
                }}
              >
                <img
                  src={images?.[0]?.mediaLink || "/placeholder.jpg"}
                  alt="Hotel"
                />
              </div>

              <div className="tgs-gallery-right">
                {images.slice(1, 5).map((img, i) => {
                  const idx = i + 1;
                  const isLast = i === 3;
                  const remaining = images.length - 5;

                  return (
                    <div
                      key={idx}
                      className="tgs-thumb"
                      onClick={() => {
                        setIsOpen(true);
                        setPhotoIndex(idx);
                      }}
                    >
                      <img src={img.mediaLink} alt="" />
                      {isLast && remaining > 0 && (
                        <div className="tgs-overlay">
                          <div className="tgs-overlay-text">
                            +{remaining} more
                            <span>View more</span>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="tgs-header">
              {/* Left info */}
              <div className="tgs-header-left">
                <h2 className="tgs-title">{name}</h2>

                <div className="tgs-sub">
                  <span className="tgs-location">
                    <MdOutlinePlace /> {locality}
                  </span>

                  <span className="tgs-rating">
                    {"★".repeat(Math.floor(starRating || 4))}
                    {"☆".repeat(5 - Math.floor(starRating || 4))}
                  </span>
                </div>
              </div>

              {/* Right actions */}
              <div className="tgs-actions">
                <div className="tgs-price">
                  ₹ {Number(standardPrice || 0).toLocaleString("en-IN")}
                  <span>/night</span>
                </div>

                <div className="tgs-btns">
                  <a href="#rooms" className="btn-primary">
                    Select Rooms
                  </a>
                  <a href="#rooms" className="btn-primary">
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="tgs-tabs">
            <a href="#rooms">Rooms</a>
            <a href="#overview">Overview</a>
            <a href="#location">Location</a>
            <a href="#facilities">Facilities</a>
            <a href="#policies">Policies</a>
            <a href="#reviews">Reviews</a>
          </div>
          <div className="tgs-room-card" id="rooms">
            {roomtypes.map((item) => (
              <div className="tgs-room-row" key={item._id}>
                {/* Room info */}
                <div className="tgs-room-info">
                  <img
                    src={item.images?.[0]?.mediaLink || "/placeholder.jpg"}
                    alt={item.roomTypeId?.name}
                  />

                  <div className="tgs-room-text">
                    <h5>{item.roomTypeId?.name}</h5>

                    <div className="tgs-room-badges">
                      {item.breakfast && <span>Breakfast Included</span>}
                      {item.lunchOrdinner && <span>Dinner Included</span>}
                    </div>
                  </div>
                </div>

                {/* Benefits */}
                <div className="tgs-room-benefits">
                  {item.breakfast && <p>✔ Room with Breakfast</p>}
                  {item.lunchOrdinner && <p>✔ Room with Dinner</p>}
                </div>

                {/* Price */}
                <div className="tgs-room-price">
                  ₹ {getRoomTotalPrice(item).toLocaleString("en-IN")}
                  <span>/night</span>
                </div>

                {/* Action */}
                <div className="tgs-room-action">
                  <button className="btn-primary">Book Now</button>
                </div>
              </div>
            ))}
          </div>
          <section className="tgs-overview" id="overview">
            <h4 className="tgs-section-title">Overview</h4>

            <div className="tgs-overview-content">
              <HTMLRenderer htmlContent={description} />
            </div>
          </section>
          <section className="tgs-location" id="location">
            <h4 className="tgs-section-title">Nearby Places</h4>

            <div className="tgs-location-list">
              {nearbyPlaces.map((item, index) => (
                <div
                  className="tgs-location-item"
                  key={item._id || `near-${index}`}
                >
                  <div className="tgs-location-left">
                    <MdOutlinePlace className="tgs-location-icon" />
                    <span className="tgs-location-name">{item.name}</span>
                  </div>

                  <div className="tgs-location-right">{item.description}</div>
                </div>
              ))}
            </div>
          </section>
          <section className="tgs-facilities" id="facilities">
            <h4 className="tgs-section-title">Facilities</h4>

            <div className="tgs-facilities-grid">
              {amenities.map((item, index) => (
                <div
                  className="tgs-facility-item"
                  key={item._id || `amen-${index}`}
                >
                  <img
                    src={item.iconUrl}
                    alt={item.name}
                    className="tgs-facility-icon"
                  />
                  <span>{item.name}</span>
                </div>
              ))}
            </div>
          </section>
          <section className="tgs-policies" id="policies">
            <h4 className="tgs-section-title">Policies</h4>

            <div className="tgs-policies-content">
              <HTMLRenderer htmlContent={bookingPolicy} />
            </div>
          </section>
        </div>
      </Container>
      {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          index={photoIndex}
          slides={slides}
          plugins={[Zoom, Thumbnails]}
          on={{ view: ({ index }) => setPhotoIndex(index) }}
        />
      )}

      {/* Footer */}
      <Footer />
    </>
  );
}
